import { defineComponent as _defineComponent } from 'vue'
import { computed, type PropType } from 'vue'
import { useImpactEditContext } from '~/functions/useImpactEditContext'
import {
  getImpactSectionBindings,
  type ImpactSectionBindingOptions,
} from '~/functions/impact-section-bindings'
import type {
  ImpactGoalType,
  ImpactSolutionType,
  ImpactType,
  TemplateEngineContext,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactSectionPage',
  props: {
  sectionId: {
    type: Number,
    required: true,
  },
  context: {
    type: [String, Number] as PropType<TemplateEngineContext>,
    required: true,
  },
  ventureId: {
    type: String,
    required: false,
  },
  impactGoal: {
    type: Object as PropType<Partial<ImpactGoalType> | ImpactGoalType>,
    required: false,
  },
  impact: {
    type: Object as PropType<ImpactType | Record<string, unknown>>,
    required: false,
  },
  impactSolution: {
    type: Object as PropType<ImpactSolutionType | Record<string, unknown>>,
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  bindingOverrides: {
    type: Object as PropType<ImpactSectionBindingOptions>,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const ctx = useImpactEditContext(props)

const sectionStyle = computed(() =>
  props.rounded ? 'border-radius: 12px !important' : undefined,
)

const sectionBindings = computed(() => ({
  ...getImpactSectionBindings(props.sectionId),
  ...props.bindingOverrides,
}))

const dynamicBindings = computed(() => ({
  sectionId: props.sectionId,
  context: props.context,
  impactId: ctx.impact.value?.id,
  impactSolutionId: ctx.impactSolution.value?.id,
  accountId: ctx.accountId.value,
  impactData: ctx.impact.value,
  impactGoalData: ctx.impactGoal.value,
  impactSolutionData: ctx.impactSolution.value,
  ghgSavingPotentialId: ctx.ghgSavingPotential.value?.id,
  ghgSavingPotentialData: ctx.ghgSavingPotential.value,
  disabled: !ctx.impactEditable.value,
  excludeQuestionIxIds: sectionBindings.value.excludeQuestionIxIds,
  onlyQuestionIxIds: sectionBindings.value.onlyQuestionIxIds,
  inputTypeForIxId: sectionBindings.value.inputTypeForIxId,
  normalizeValueByIxId: sectionBindings.value.normalizeValueByIxId,
  validatorByIxId: sectionBindings.value.validatorByIxId,
}))

return { __sfc: true,props, ctx, sectionStyle, sectionBindings, dynamicBindings }
}

})